module.exports = __webpack_public_path__ + "static/media/person2.cf614369.png";